export interface Schema {
  /** Name of the project to target. */
  project?: string;
  /** Url to your GraphQL endpoint */
  endpoint?: string;
}
